export const ROLES = Object.freeze({
  ADMIN: 'admin',
  ADMINISTRATIVE: 'administrative',
  SUPER: 'super',
  GESTORE: 'gestore',
  B2B: 'b2b',
  CDI: 'cdi',
  VISUALIZZATORE: 'visualizzatore',
  AUTISTA: 'autista',
});

export const PERMISSIONS = Object.freeze({
  VIEW_INVOICES: [ROLES.ADMINISTRATIVE, ROLES.SUPER],
  VIEW_ANALYTICS: [ROLES.ADMIN, ROLES.ADMINISTRATIVE, ROLES.SUPER],
  VIEW_PLANNING: [ROLES.ADMIN, ROLES.ADMINISTRATIVE, ROLES.SUPER],
  VIEW_CLIENTS: [ROLES.ADMIN, ROLES.ADMINISTRATIVE, ROLES.SUPER],
  VIEW_MANAGE: [ROLES.ADMIN, ROLES.ADMINISTRATIVE, ROLES.SUPER],
  MANAGE_USERS: [ROLES.ADMIN, ROLES.SUPER],
  VIEW_FLEET_CHECKS: [ROLES.ADMIN, ROLES.ADMINISTRATIVE, ROLES.SUPER],
  VIEW_ALL_DATA: [ROLES.ADMIN, ROLES.ADMINISTRATIVE, ROLES.SUPER],
  IMPERSONA: [ROLES.SUPER],
  MANAGE_INVOICE_NUMBER: [ROLES.ADMINISTRATIVE, ROLES.SUPER],
});

/**
 * @param {Object} userRole - role object from Firestore, e.g. { admin: true }
 * @param {string} permission - key from PERMISSIONS
 */
export const hasPermission = (userRole, permission) => {
  if (!userRole || !PERMISSIONS[permission]) return false;
  return PERMISSIONS[permission].some((r) => userRole[r] === true);
};
